import { AuthError } from '@infra/auth/AuthService';

export const LICENCE_SUBSCRIBE_URL = 'https://nexxus.ga/telechargement-client.html#souscrire';

export function isLicenceExpiredError(err: unknown): boolean {
  return err instanceof AuthError && err.code === 'LICENCE_EXPIRED';
}

export function expiredLicenceCopy(trial = true): { title: string; body: string; cta: string } {
  if (trial) {
    return {
      title: 'Essai terminé',
      body: 'Votre période d’essai est terminée. Vous pouvez encore consulter vos données. Pour continuer à saisir, finalisez votre souscription.',
      cta: 'Finaliser la souscription',
    };
  }
  return {
    title: 'Licence arrivée à échéance',
    body: 'Votre licence est arrivée à échéance. Vous pouvez encore consulter vos données. Pour reprendre les saisies, renouvelez votre abonnement.',
    cta: 'Renouveler l’abonnement',
  };
}

export async function openLicenceSubscribePage(): Promise<void> {
  if (window.electron?.openExternal) {
    await window.electron.openExternal(LICENCE_SUBSCRIBE_URL);
    return;
  }
  window.open(LICENCE_SUBSCRIBE_URL, '_blank', 'noopener');
}
